/**
 * SMS utilities and constants
 */

export const CAMPAIGN_NAMES = {
  1: 'Founding Members',
  2: 'Island Energy', 
  3: 'Grand Opening'
};

export const PERSONALIZATION_TOKENS = [
  { token: '{{name}}', description: 'Full name' },
  { token: '{{first_name}}', description: 'First name' },
  { token: '{{coupon_code}}', description: 'Discount code' },
];

export const TEMPLATE_CATEGORIES = [
  { value: 'general', label: 'General' },
  { value: 'promotion', label: 'Promotion' },
  { value: 'announcement', label: 'Announcement' },
  { value: 'reminder', label: 'Reminder' },
];

export const calculateMessageStats = (message) => {
  const charCount = message.length;
  const segmentCount = Math.ceil(charCount / 160) || 1;
  const remainingChars = (segmentCount * 160) - charCount;
  return { charCount, segmentCount, remainingChars };
};
